import { InlineNotification } from '@msaf/core-react'

interface NoResultsComponentProps {
  message: string
}

export function NoResultsComponent({ message }: NoResultsComponentProps) {
  return <InlineNotification isDismissable={false}>{message}</InlineNotification>
}
